import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  SuppliersWorkspace,
  type SuppliersWorkspaceProps,
} from "@/features/staff/purchasing/suppliers-workspace"

export default function StaffLocationManageSuppliersIndex(props: SuppliersWorkspaceProps) {
  return (
    <StaffLayout>
      <SuppliersWorkspace {...props} />
    </StaffLayout>
  )
}
